APP.video = function () {
	const el = $('.game');
	const warning = $('.warning');
	const warningWebkit = $('.warning-webkit');

	const loader = el.find('.loader');

	const player1 = document.querySelector('#player1');
	const player2 = document.querySelector('#player2');

	const register = el.find('.register');
	const selectDealer = register.find('[name="dealer_id"]');
	const selectDealerOption = selectDealer.data('label-dealer');
	const selectDealerInputPlaceholder = selectDealer.data('input-placeholder');
	const tagsModel = el.find('[name="tags_model"]');
	const company = el.find('[name="o2o-company"]');

	const [getLocation, setLocation] = useLocation();
	const [getDealer, setDealer] = useDealer();
	const [getDealerItems, setDealerItems] = useDealerItems();

	const getLocationBtn = el.find('.dealer-current');
	const getLocationBtnText = getLocationBtn.data('text-nearby');
	const getLocationBtnTextButton = getLocationBtn.data('text-nearby-btn');

	const intro = el.find('.intro');
	const btnPlay = intro.find('.btn-play');

	const video = el.find('.video');
	const video16by9 = video.find('.video-16by9');
	const video9by16 = video.find('.video-9by16');

	const guide = video.find('.guide');
	const btnStart = guide.find('.btn-start');

	const count = video.find('.count');
	const countNumber = count.find('.count-number');

	const resultLost = video.find('.result-lost');
	const btnRestart = resultLost.find('.btn-restart');

	const resultWin = video.find('.result-win');
	const btnReplay = resultWin.find('.btn-restart');
	const btnShare = resultWin.find('.btn-share');

	let dataSubmit = {};
	let dataWin = {
		data_id: '',
		total: 0,
		win: 0,
	};

	let isPlaying = false;
	let timeLeft = 3;
	let timerID;

	function detectWebview() {
    if (typeof window === undefined) { return false };

    let navigator = window.navigator;

    const standalone = navigator.standalone;
    const userAgent = navigator.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
    const ios_ipad_webview = ios && !safari;

		// $('.intro-body .btn-text').text(userAgent);
		// console.log(userAgent);
    return ios ? ( (!standalone && !safari) || ios_ipad_webview ) : false;
	}

	function init() {
		if (el.length === 0) return;

		detectDevice();
		APP.resize(detectDevice);

		if(detectWebview()) {
			// warningWebkit.show();
		}

		const mmv_campaign = getParameterByName('mmv_campaign')
			? getParameterByName('mmv_campaign')
			: getCookie('mmv_campaign');

		if (tagsModel.val()) {
			company.val(`${tagsModel.val()}`);
			if (mmv_campaign) {
				company.val(`${tagsModel.val()},${mmv_campaign}`);
			}
		} else if (mmv_campaign) {
			company.val(`${mmv_campaign}`);
		}

		const searchParams = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		if (searchParams.position) {
			position.val(searchParams.position);
			form_type.val(searchParams.position);
		}

		detectVideo();
		APP.resize(detectVideo);

		btnShare.on('click', function (e) {
			e.preventDefault();
			var fbpopup = window.open("https://www.facebook.com/sharer/sharer.php?u=https://www.mitsubishi-motors.com.vn/xfc-concept/mini-game?status=success", "pop", "width=600, height=400, scrollbars=no");
    	return false;
			// FB.ui({
			// 	method: 'share',
			// 	// picture: 'https://www.mitsubishi-motors.com.vn/public/img/mini-game/xfc-concept-model.jpg',
			// 	name: 'XFC Concept | Mitsubishi Motors Việt Namthe name',
			// 	link: 'https://www.mitsubishi-motors.com.vn/xfc-concept/mini-game?status=success',
			// 	caption: '',
			// 	description: '',
			// 	message: '',
			// });
		});

		//APP.getDealers(selectDealer, selectDealerOption, selectDealerInputPlaceholder);

		// getLocationBtn.on('click', async function (evt) {
		// 	evt.preventDefault();
		// 	await handleInitialLoad();
		// });

		// navigator.permissions.query({ name: 'geolocation' }).then(async (permissionStatus) => {
		// 	if (permissionStatus.state == 'granted') {
		// 		await handleInitialLoad();
		// 	}
		// });

		player1.addEventListener('touchstart', () => {
			if (isPlaying && !player1.paused) {
				player1.pause();
				isPlaying = false;

				const _currentTime = player1.currentTime;
				player1.currentTime = _currentTime;
				player2.currentTime = _currentTime;

				setTimeout(() => {
					if (_currentTime >= 1.235999 && _currentTime <= 1.267933) {
						dataWin.win = dataWin.win + 1;
						//youWin(dataWin);
						gsap.set(resultWin, {
							display: 'block',
						});
					} else {
						gsap.set(resultLost, {
							display: 'block',
						});
					}
				}, 300);
			}
		});

		player2.addEventListener('touchstart', () => {
			if (isPlaying && !player2.paused) {
				player2.pause();
				isPlaying = false;
				const _currentTime = player2.currentTime;
				player2.currentTime = _currentTime;
				player1.currentTime = _currentTime;

				setTimeout(() => {
					if (_currentTime >= 1.235999 && _currentTime <= 1.267933) {
						dataWin.win = dataWin.win + 1;
						//youWin(dataWin);
						gsap.set(resultWin, {
							display: 'block',
						});
					} else {
						gsap.set(resultLost, {
							display: 'block',
						});
					}
				}, 150);
			}
		});

		// const userData = localStorage.getItem('userData')
		// 	? JSON.parse(localStorage.getItem('userData'))
		// 	: null;

		// if (userData) {
		// 	$('[name="name"]').val(userData?.name);
		// 	$('[name="phone"]').val(userData?.phone);
		// 	$('[name="email"]').val(userData?.email);
		// }

		// APP.validate('.form-register', {
		// 	isAjax: true,
		// 	onComplete: (response) => {
		// 		const dealer_name =
		// 			selectDealer.find('option:selected').val() === ''
		// 				? ''
		// 				: selectDealer.find('option:selected').text();

		// 		dataSubmit = {
		// 			utm_source: getParameterByName('utm_source')
		// 				? getParameterByName('utm_source')
		// 				: getCookie('utm_source'),
		// 			utm_content: getParameterByName('utm_content')
		// 				? getParameterByName('utm_content')
		// 				: getCookie('utm_content'),
		// 			utm_medium: getParameterByName('utm_medium')
		// 				? getParameterByName('utm_medium')
		// 				: getCookie('utm_medium'),
		// 			utm_campaign: getParameterByName('utm_campaign')
		// 				? getParameterByName('utm_campaign')
		// 				: getCookie('utm_campaign'),
		// 			mmv_campaign: getParameterByName('mmv_campaign')
		// 				? getParameterByName('mmv_campaign')
		// 				: getCookie('mmv_campaign'),
		// 			form_type: getParameterByName('form_type')
		// 				? getParameterByName('form_type')
		// 				: 'test-drive',
		// 			location: window.location.href,
		// 			env: getParameterByName('env') ? getParameterByName('env') : 'dev',
		// 		};

		// 		const data = {
		// 			...response,
		// 			...dataSubmit,
		// 			dealer_name,
		// 		};

		// 		const dataInput = data;

		// 		showLoader();

		// 		fetch(`${api}/form/testDrive`, {
		// 			method: 'POST',
		// 			headers: {
		// 				'Content-Type': 'application/json',
		// 			},
		// 			body: JSON.stringify(data),
		// 		})
		// 			.then((res) => res.json())
		// 			.then((data) => {
		// 				localStorage.setItem('userData', JSON.stringify(response));
		// 				hideLoader();
		// 				if (data.result === 'success') {
		// 					// BEGIN Send data to CDP & CRM
		// 					let tags = dataInput.tags_model;

		// 					if (dataInput.mmv_campaign) {
		// 						tags += ',' + dataInput.mmv_campaign;
		// 					}

		// 					dataWin.data_id = data.data_id;

		// 					dataLayer.push({
		// 						event: 'pangoTrack',
		// 						eventAction: 'generate_lead',
		// 						label: '',
		// 						user_data: {
		// 							email_address: dataInput.email,
		// 							phone_number: dataInput.phone,
		// 						},
		// 						cdpData: {
		// 							properties: {
		// 								fullname: dataInput.name,
		// 								email: dataInput.email,
		// 								phone: dataInput.phone,
		// 								listTagsModel: dataInput.tags_model,
		// 								listTagsCampaign: dataInput.mmv_campaign,
		// 								company: company.val(),
		// 								address: dataInput.dealer_name,
		// 								note: dataInput.note,
		// 								position: dataInput.position,
		// 							},
		// 						},
		// 					});
		// 					// End

		// 					gsap.set(guide, {
		// 						display: 'block',
		// 					});
		// 					gsap.to(register, {
		// 						duration: 0.4,
		// 						x: '-100%',
		// 						ease: 'power1.out',
		// 						delay: 0.4,
		// 						onComplete: () => {
		// 							gsap.set(register, {
		// 								display: 'none',
		// 								x: 0,
		// 							});
		// 						},
		// 					});
		// 				} else {
		// 					APP.toasts({
		// 						message: data.errorMessage,
		// 					});
		// 				}
		// 			})
		// 			.catch(() => {
		// 				hideLoader();
		// 			});
		// 	},
		// });

		btnPlay.on('click', () => {
			// gsap.set(register, {
			// 	display: 'block',
			// });
			gsap.set(guide, {
				display: 'block',
			});
			gsap.to(intro, {
				duration: 0.4,
				x: '-100%',
				ease: 'power1.out',
				onComplete: () => {
					gsap.set(intro, {
						display: 'none',
						x: 0,
					});
				},
			});
			// Trick to autoplay video on mobile
			player1.play();
			player1.pause();
			player2.play();
			player2.pause();
		});

		btnStart.on('click', () => {
			gsap.set(guide, {
				display: 'none',
			});

			gsap.set(count, {
				display: 'block',
			});
			dataWin.total = dataWin.total + 1;
			timerID = setInterval(countdown, 1000);
		});

		btnRestart.on('click', () => {
			gsap.set(count, {
				display: 'block',
			});

			gsap.set(resultLost, {
				display: 'none',
			});

			player1.currentTime = 0;
			player2.currentTime = 0;
			dataWin.total = dataWin.total + 1;
			timerID = setInterval(countdown, 1000);
		});

		btnReplay.on('click', () => {
			gsap.set(count, {
				display: 'block',
			});

			gsap.set(resultLost, {
				display: 'none',
			});

			player1.currentTime = 0;
			player2.currentTime = 0;
			btnShare.removeClass('d-none');
			btnReplay.addClass('d-none');
			gsap.set(resultWin, {
				display: 'none',
			});
			dataWin.total = dataWin.total + 1;
			timerID = setInterval(countdown, 1000);
		});

		btnShare.on('click', function () {
			btnShare.addClass('d-none');
			btnReplay.removeClass('d-none');
		});
	}

	// function youWin(data) {
	// 	fetch(`${api}/form/testDrive`, {
	// 		method: 'PUT',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 		},
	// 		body: JSON.stringify(data),
	// 	});
	// }

	function useLocation() {
		let _location = null;

		function getLocation() {
			return _location;
		}

		function setLocation(data) {
			_location = { ...data };
		}

		return [getLocation, setLocation];
	}

	function useDealer() {
		let _dealer = null;

		function getDealer() {
			return _dealer;
		}

		function setDealer(data) {
			_dealer = [...data];
		}

		return [getDealer, setDealer];
	}

	function useDealerItems() {
		let _dealerItems = null;

		function getDealerItems() {
			return _dealerItems;
		}

		function setDealerItems(data) {
			_dealerItems = data;
		}

		return [getDealerItems, setDealerItems];
	}

	function showLoader() {
		loader.addClass(CLASS._show);
	}

	function hideLoader() {
		loader.removeClass(CLASS._show);
	}

	function countdown() {
		if (timeLeft <= 1) {
			clearTimeout(timerID);
			timeLeft = 3;
			isPlaying = true;
			gsap.set(count, {
				display: 'none',
			});
			if (APP.isLandscape()) {
				player2.play();
			} else {
				player1.play();
			}
		} else {
			timeLeft--;
		}

		countNumber.html(`${timeLeft}`);
	}

	function detectVideo() {
		const detect = APP.isLandscape();
		if (detect) {
			gsap.set(video16by9, {
				display: 'none',
			});
			gsap.set(video9by16, {
				display: 'block',
			});
		} else {
			gsap.set(video16by9, {
				display: 'block',
			});
			gsap.set(video9by16, {
				display: 'none',
			});
		}
	}

	function haversineDistance(mk1, mk2) {
		const R = 3958.8;
		const rlat1 = mk1.lat * (Math.PI / 180);
		const rlat2 = mk2.lat * (Math.PI / 180);
		const difflat = rlat2 - rlat1;
		const difflon = (mk2.lng - mk1.lng) * (Math.PI / 180);

		const d =
			2 *
			R *
			Math.asin(
				Math.sqrt(
					Math.sin(difflat / 2) * Math.sin(difflat / 2) +
						Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
				)
			);
		return d;
	}

	function sortByKey(array, key) {
		return array.sort(function (a, b) {
			const x = a[key];
			const y = b[key];
			return x < y ? -1 : x > y ? 1 : 0;
		});
	}

	async function getData(url) {
		const response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const res = await response.json();

		return res;
	}

	async function addDistance() {
		const dealers = getDealer();
		const currentLocation = getLocation();
		const curLocation = {
			lat: currentLocation.lat,
			lng: currentLocation.lng,
		};

		if (curLocation.lat !== 0 && curLocation.lng !== 0) {
			dealers.map((dealer) => {
				const posLocation = dealer.acf.dealer_location;
				const distanceKMNew = haversineDistance(curLocation, posLocation);
				if (distanceKMNew) {
					dealer['distance'] = distanceKMNew;
					dealer['distanceValue'] = distanceKMNew;
				}
			});
			const tmpDealers = Object.assign([], getDealer());
			let dealerData = sortByKey(tmpDealers, 'distanceValue');
			const dealerId = dealerData[0].id;
			APP.sortDealers(
				selectDealer,
				selectDealerOption,
				selectDealerInputPlaceholder,
				dealerId,
				dealerData,
				getLocationBtnText,
				getDealerItems()
			);
			setTimeout(() => {
				selectDealer.val(dealerId).trigger('change');
			}, 1000);
		}
	}

	async function renderCurrentLocation() {
		showLoader();
		if (getLocation() === null || getLocation().lat === 0 || getLocation().lng === 0) {
			const position = await getLocationCurrent();
			const curLocation = { lat: position.coords.latitude, lng: position.coords.longitude };
			setLocation(curLocation);
			await addDistance();
			getLocationBtn.find('span').text(getLocationBtnTextButton);
		} else {
			await addDistance();
		}
		hideLoader();
	}

	async function handleInitialLoad() {
		if (getDealer() === null) {
			const data = await getData(`${api}/wp/dealerNetwork`);
			setDealer(data.items);
			setDealerItems(data);
		}
		await renderCurrentLocation();
	}

	function getLocationCurrent() {
		return new Promise(function (resolve, reject) {
			return navigator.geolocation.getCurrentPosition(resolve, reject);
		});
	}

	function detectDevice() {
		if (APP.isMT()) {
			warning.hide();
		} else {
			warning.show();
		}
	}

	init();
};
